export const TOOLTIP_TITLES = {
  THRESHOLD:
    'The threshold of a Safe Account specifies how many owners need to confirm a Safe Account transaction before it can be executed.',
} as const
